<template>
  <BuybackMainContainer
    :data="{
      type: 'valuate',
      valuateOnly: true,
      selectedProductId: null,
      selectedManufacturer: null,
      selectedPlanId: null,
      orderNumber: null,
      downPaymentTime: null,
    }"
    :valuate-only-heading="configData.Heading"
    :valuate-only-ingress="configData.Ingress"
    :valuate-only-text="configData.Text"
    :valuate-only-steps="configData.Steps"
  ></BuybackMainContainer>
</template>

<script lang="ts" setup>
interface Props {
  configData: {
    Heading?: string;
    Ingress?: string;
    Text?: string;
    Steps?: {
      heading: string;
      text: string;
    }[];
  };
}

defineProps<Props>();
</script>

<style scoped></style>
